const BASE_URL = process.env.REACT_APP_BASE_URL;

const EMPLOYEE_URL = {
  LOGIN: BASE_URL + "auth/employee/login/",
  REFRESH_TOKEN: BASE_URL + "emp/auth/refresh/",
  GET_EMPLOYEE_PERMISSION: BASE_URL + "auth/employee/menu-permissions/?comp_id=",


  GET_ALL_COMPANIES: BASE_URL + "company-employee/",
  ADD_COMPANY: BASE_URL + "company-employee/",
  GET_COMPANY: BASE_URL + "company-employee/",
  UPDATE_COMPANY: BASE_URL + "company-employee/",
  DELETE_COMPANY: BASE_URL + "company-employee/",

  GET_EMP_NOTIFICATION: BASE_URL + "emp/notifications/",


};

export default EMPLOYEE_URL;